module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Events\n    ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.default_filter,
      "label": "Date Range",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.allEvents.length > 0) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.allEvents,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.submitdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "padding-right": "10px !important",
            "width": "164px"
          }
        }, [_c('div', {
          staticClass: "avatar",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [(props.item.user.avatar) ? _c('img', {
          attrs: {
            "src": props.item.user.avatar,
            "alt": "logo"
          }
        }) : _vm._e(), _vm._v(" "), (!props.item.user.avatar) ? _c('img', {
          attrs: {
            "src": "https://randomuser.me/api/portraits/men/88.jpg",
            "alt": "logo"
          }
        }) : _vm._e()]), _vm._v("\n        " + _vm._s(props.item.user.firstname) + " " + _vm._s(props.item.user.lastname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.user.company.companylegalname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("sliceText")(props.item.title)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.eventdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("status")(props.item.approvalStatus)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 1,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(1, props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": "",
            "disabled": props.item.approvalStatus === 2
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(2, props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'activeDialog')
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": "",
            "medium": "",
            "disabled": !props.item.approvalStatus == 1 && props.item.approvalStatus !== 2
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'emailDialog')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'dialog')
            }
          }
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n    ")]
      }
    }], null, false, 3851595190)
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "width": "790px"
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "color": "white",
      "prominent": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Event Details")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("title")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.title))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.user.firstname) + " " + _vm._s(_vm.selectedItem.user.lastname))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.eventdate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Event date")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("watch_later")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.starteventtime) + " " + _vm._s(_vm.selectedItem.endeventtime))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Event time")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.location))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("event_note")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.description))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("link")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('a', {
    attrs: {
      "href": _vm.selectedItem.link
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.link))])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Confim Email")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to mail "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.user.firstname))]), _vm._v("?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false;
        _vm.emailUser(_vm.selectedItem.uid, _vm.selectedItem.approvalStatus)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.user.firstname) + "'s")]), _vm._v(" event?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRow()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d71da0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Request/events.vue
// module id = 1216
// module chunks = 3 4